const SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" viewBox="0 0 192 192">
  <defs>
    <path id="f" d="M-3 -13v6a3 3 0 0 0 6 0v-6M0 -13v6.5M0 -4v17"/>
    <path id="k" d="M1 -13v26M1 -13c-3 2.5 -3 8 0 10.5"/>
    <path id="s" d="M0 -13a3 4.5 0 0 0 0 9a3 4.5 0 0 0 0 -9M0 -4v17"/>
    <path id="c" d="M1 -13L2 12M1 -13C-4 -6 -4 2 1 4"/>
    <path id="a" d="M-4 -4v-5a3 3 0 0 1 3 -3h2a3 3 0 0 1 3 3v5ZM-1.5 -10v4M1.5 -10v4M0 -4v17"/>
    <path id="w" d="M0 -13C-4.5 -12 -4.5 -5 0 -4C4.5 -5 4.5 -12 0 -13M0 -13C-2 -10 -2 -6 0 -4M0 -13C2 -10 2 -6 0 -4M0 -12v8M0 -4v17"/>
    <g id="p">
      <use href="#f" transform="translate(-5.5 0) rotate(-5)"/>
      <use href="#k" transform="translate(5.5 0) rotate(5)"/>
    </g>
  </defs>
  <g fill="none" stroke="#1B2420" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" opacity="1">
    <use href="#p" transform="translate(24 24) rotate(-6)"/>
    <use href="#s" transform="translate(72 24) rotate(12)"/>
    <use href="#p" transform="translate(120 24) rotate(7)"/>
    <use href="#c" transform="translate(168 24) rotate(-8)"/>
    <use href="#a" transform="translate(24 72) rotate(6)"/>
    <use href="#p" transform="translate(72 72) rotate(4)"/>
    <use href="#w" transform="translate(120 72) rotate(-10)"/>
    <use href="#p" transform="translate(168 72) rotate(-7)"/>
    <use href="#p" transform="translate(24 120) rotate(6)"/>
    <use href="#c" transform="translate(72 120) rotate(9)"/>
    <use href="#p" transform="translate(120 120) rotate(-5)"/>
    <use href="#s" transform="translate(168 120) rotate(-12)"/>
    <use href="#w" transform="translate(24 168) rotate(8)"/>
    <use href="#p" transform="translate(72 168) rotate(-8)"/>
    <use href="#a" transform="translate(120 168) rotate(-6)"/>
    <use href="#p" transform="translate(168 168) rotate(7)"/>
  </g>
</svg>`

export const CATERING_BOT_PATTERN_DATAURI = `data:image/svg+xml,${encodeURIComponent(SVG)}`
export const CATERING_BOT_PATTERN_OPACITY = 0.07
